import { Checkbox, Table } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import type { FactureType } from '@/types';
import { formatMonetaire, utils_string } from '@/utils';

interface ModalEncaissementLoocTableBodyRowProps {
  nombreFactures: number;
  facture: FactureType;
  selected: number[];
  produitsMontants: boolean;
  onSelect: (checked: boolean, identifiant: number) => void;
  onOpenPdf: (identifiantDocument: number) => void;
}

const ModalEncaissementLoocTableBodyRow = (props: ModalEncaissementLoocTableBodyRowProps) => {
  const { nombreFactures, facture, selected, produitsMontants, onSelect } = props;

  const { payeur, numero, lignes, lieuLoue } = facture;
  const { nom, prenom, civilite } = payeur || {};
  const { abreviation } = civilite || {};

  const restePayer = React.useMemo(() => _.sumBy(lignes, 'reste'), [lignes]);

  const isSelected = React.useMemo(
    () => _.includes(selected, facture.identifiant),
    [selected, facture.identifiant],
  );

  return (
    <Table.Row {...(isSelected && { className: 'selected looc' })}>
      {nombreFactures > 1 && (
        <Table.Cell textAlign="center">
          <Checkbox
            data-testid="checkbox-select"
            checked={_.includes(selected, facture.identifiant)}
            onChange={(e, data) => onSelect(data.checked, facture.identifiant)}
          />
        </Table.Cell>
      )}
      <Table.Cell style={{ width: 175 }}>
        <div style={{ display: 'flex' }}>
          <div className="textEllipsis" style={{ flex: 1 }} title={numero}>
            {numero}
          </div>
        </div>
      </Table.Cell>
      <Table.Cell>
        {`${abreviation || ''} ${utils_string.toOfficialLastname(nom || '')} ${utils_string.toOfficialFirstname(prenom || '')}`}
      </Table.Cell>
      <Table.Cell>{lieuLoue}</Table.Cell>
      {produitsMontants && (
        <Table.Cell style={{ padding: 0 }}>
          <Table style={{ border: 'none' }}>
            <Table.Body>
              {_.map(lignes, (ligne) => (
                <Table.Row {...(isSelected && { className: 'selected looc' })}>
                  <Table.Cell>{ligne?.produit?.libelle}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Table.Cell>
      )}
      <Table.Cell textAlign="right">
        {isSelected ? <b>{formatMonetaire(restePayer)}</b> : formatMonetaire(restePayer)}
      </Table.Cell>
    </Table.Row>
  );
};

export default ModalEncaissementLoocTableBodyRow;
